// extracted by mini-css-extract-plugin
module.exports = {"welcome_screen":"welcome-screen_welcome_screen__1J_8z","wrapper":"welcome-screen_wrapper__3nHtW","inner":"welcome-screen_inner__AClz5"};